<template>
    <div>
        <div class="success-container">
            <div class="card-wrapper">
                <div class="card-icon">
                    <img src="@/assets/images/onboarding/successIcon.svg" alt="">
                </div>
                <div class="card-title-wrapper">
                    <div class="card-title">
                        <h1>Great progress!</h1>
                        <div class="title-icon"></div>
                    </div>
                    <h3 class="card-subtitle">
                        You have successfully completed the basic setup to access the full
                        platform. You just unlocked additional store settings and platform
                        features that you can now explore and enjoy.
                    </h3>
                </div>
                <div>
                    <button @click="updateState" class="card-btn">
                        <span v-if="!isLoading">Continue</span>
                        <span v-if="isLoading">
                            <img class="spinner" src="@/assets/images/onboarding/loading.svg" alt="loading">
                        </span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            isLoading: false,
        }
    },
    methods: {
        updateState() {
            this.isLoading = true
            setTimeout(() => {
                window.location.reload(true);
            }, 1000)

            setTimeout(() => {
                this.$store.commit('onboarding/setModuleAvailableModal', false);
                localStorage.removeItem('successModal');
            }, 1000)


        },
    },
}
</script>
<style lang="scss" scoped>
.spinner {
    animation: rotate 1.5s linear infinite;
    /* Add rotation animation */
}

@keyframes rotate {
    from {
        transform: rotate(0deg);
        /* Start rotation from 0 degrees */
    }

    to {
        transform: rotate(360deg);
        /* Rotate 360 degrees (full circle) */
    }
}

.success-container {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 99;
}

.card-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    border-radius: 8px;
    background-color: #FFF;
    width: 401px;
}

.card-icon {
    margin-top: 13px;
    margin-bottom: 17px;
}

.card-title-wrapper {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
}

.card-subltitle {
    display: flex;
    justify-content: center;

}

.card-title {
    h1 {
        margin: 0px;
        color: #2F3941;
        text-align: center;
        font-family: MainFontRegular, sans-serif;
        font-size: 18px;
        font-style: normal;
        line-height: 22px;
        margin-bottom: 23px;
    }
}



.card-subtitle {
    margin: 0px;
    color: #49545C;
    text-align: center;
    font-family: MainFontRegular, sans-serif;
    font-size: 13px;
    font-style: normal;
    line-height: 20px;
    margin-bottom: 30px;
    padding: 0px 35px;
}


.card-btn {
    border-radius: 8px;
    background: #53B6B2;
    display: flex;
    width: 364px;
    height: 40px;
    padding: 15px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    flex-shrink: 0;
    color: #FFF;
    font-family: MainFontRegular, sans-serif;
    font-size: 14px;
    font-style: normal;
    line-height: normal;
    border: none;
    margin-bottom: 24px;
}
</style>